const testimonials = [
  {
    name: "Sarah Mitchell",
    location: "Johnson City, TN",
    rating: 5,
    text: "I'm an ETSU nursing student and my study abroad program in Germany started in 10 days. I had no idea my passport was expired. Fast Passport Center got me an emergency appointment and I had a brand new passport in 48 hours. I almost missed my semester.",
    service: "Emergency — ETSU Study Abroad",
    initial: "SM",
  },
  {
    name: "Dr. James Hartwell",
    location: "Johnson City, TN",
    rating: 5,
    text: "I'm a physician at Mountain States Medical Center attending the WHO Global Health Summit in Geneva. My passport renewal got delayed through the post office. Fast Passport Center rescued the application and had it back in 4 days. Incredible service for Tri-Cities professionals.",
    service: "Rush Renewal — WHO Summit",
    initial: "JH",
  },
  {
    name: "Rebecca Torres",
    location: "Jonesborough, TN",
    rating: 5,
    text: "My husband and I planned our anniversary trip to Spain for months. We started the renewal process too late and panicked. The team here walked us through everything, caught a mistake on our photos, and got both passports back in under a week. Jonesborough to Barcelona — made it!",
    service: "Rush Renewal — Spain Trip",
    initial: "RT",
  },
  {
    name: "Marcus Chen",
    location: "Gray, TN",
    rating: 5,
    text: "I needed a passport for my son's first international trip — a church mission to Costa Rica. Being first-time applicants, we didn't know what we were doing. Fast Passport Center handled everything including the parental consent form. So relieved.",
    service: "New Application — Child Passport",
    initial: "MC",
  },
  {
    name: "Linda Owens",
    location: "Elizabethton, TN",
    rating: 5,
    text: "My mother passed away in the UK and I needed to get there in 36 hours. I called at 7pm and the team stayed on the phone to walk me through every document. I had my emergency passport by noon the next day. I will never use anyone else.",
    service: "Emergency — Family Bereavement",
    initial: "LO",
  },
  {
    name: "Tyler Brooks",
    location: "Johnson City, TN",
    rating: 5,
    text: "As a Johnson City contractor heading to a construction project in Mexico, I needed to renew my passport fast before the contract started. Fast Passport Center had it done in 5 business days including shipping. Professional and reliable service.",
    service: "Rush Renewal — Mexico Work Contract",
    initial: "TB",
  },
];

export default function JohnsonCityTestimonialsSection() {
  return (
    <section id="testimonials" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Testimonials</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Johnson City Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From ETSU students to Mountain States physicians — here's what Tri-Cities travelers say about our expedited passport services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white rounded-xl p-7 border border-gray-100 flex flex-col">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(t.rating)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-lg"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] text-white text-sm font-bold flex-shrink-0">
                  {t.initial}
                </div>
                <div>
                  <p className="font-semibold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <div className="ml-auto">
                  <span className="text-xs bg-[#F6C344]/20 text-[#1A365D] font-medium px-2 py-1 rounded-full whitespace-nowrap">{t.service}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}